import { Box, Column, Grid } from "@twilio-paste/core";

import Dialer from "../Dialer/Dialer";
import PhoneNumberInput from "../PhoneNumberInput/PhoneNumberInput";
import TwilioVoiceManager from "../WebsocketManagers/VoiceManager";

function Softphone({ numberInUse }) {
  return (
    <Box
      maxWidth={"75%"}
      maxHeight={"size80"}
      margin={"auto"}
      marginY={"space120"}
      backgroundColor={"colorBackgroundBody"}
      boxShadow={"shadowCard"}
      borderRadius={"borderRadius30"}
      borderWidth={"borderWidth10"}
      borderColor={"colorBorderWeaker"}
      borderStyle={"solid"}
    >
      <Grid>
        <Column span={12}>
          <Box padding="space60" paddingBottom={"space0"}>
            <PhoneNumberInput />
            <Grid gutter={"space40"}>
              <Column span={12}>
                <TwilioVoiceManager>
                  <Dialer />
                </TwilioVoiceManager>
              </Column>
            </Grid>
          </Box>
        </Column>
      </Grid>
    </Box>
  );
}

export default Softphone;
